import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Loader } from 'tmt-ui-kit';

import withTrip from './withTrip';

const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.55);
  ${props => !props.visible && 'display: none;'}
`;

const enhance = connect(
  state => ({
    loading: (state.trip.loading || state.session.isLoadingSessionData || !state.session.isSessionDataLoaded),
  })
);

const LoaderContainer = ({ loading }) => {
  return (
    <LoadingContainer visible={loading}>
      <Loader />
    </LoadingContainer>
  );
};

LoaderContainer.propTypes = {
  loading: PropTypes.bool,
};

export default withTrip(enhance(LoaderContainer));
